const request = {}

request.createRequest = function (params) {
  return {
    email: params.email,
    lastName: params.name.lastName,
    firstName: params.name.firstName,
    authorityId: params.authority.value
  }
}
export default { request }
